import ExploreMixin from '@/mixins/ExploreMixin'
import CreateOverview from '@/components/assemble/create/CreateOverview'
import CreateLogo from '@/components/assemble/create/CreateLogo'
import CreateName from '@/components/assemble/create/CreateName'

export default {
  name: 'Create',
  template: '#create-template',
  data () {
    return {
      teams: {},
      currentTeamNum: 0,
      didRandomize: false
    }
  },
  mixins: [ExploreMixin],
  components: { CreateOverview, CreateLogo, CreateName },
  computed: {
    createComponent () {
      let component = CreateOverview
      if (this.$route.name === 'logo') {
        component = CreateLogo
      } else if (this.$route.name === 'name') {
        component = CreateName
      }
      return component
    },
    canProceed () { return this.$store.state.teamLogo !== '' && this.$store.state.teamName !== '' && this.$store.state.teamTag !== '' },
    showFinish () {
      if (this.$route.path.includes('logo') || this.$route.path.includes('name')) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    getRandoTeamNum () {
      let teamsLength = Object.keys(this.teams).length
      return (Math.floor(Math.random() * teamsLength)) + 1 // add one because we deleted the duckycrabs
    },
    getRandoTeamStr () {
      let randoTeamNum = this.getRandoTeamNum()
      while (randoTeamNum === 5) { // no duckycrabs allowed here
        randoTeamNum = this.getRandoTeamNum()
      }
      this.currentTeamNum = randoTeamNum
      return 'team' + this.currentTeamNum
    },
    randomize () {
      this.didRandomize = true
      let randoTeamStr = this.getRandoTeamStr()
      while (randoTeamStr === this.$store.state.teamLogo) {
        randoTeamStr = this.getRandoTeamStr()
      }
      let randoTeamObj = this.teams[randoTeamStr]
      this.$store.dispatch('setTeamLogo', randoTeamStr)
      this.$store.dispatch('setTeamName', randoTeamObj.name)
      this.$store.dispatch('setTeamTag', randoTeamObj.tag)
      this.trackEvent('Team Up (Team Name and Logo)', 'Team Up (Team Name and Logo): Button: Choose for Me')
    },
    finish () {
      if (!this.canProceed) {
        this.randomize()
      }
      this.trackEvent('Team Up (Team Name and Logo)', 'Team Up (Team Name and Logo): Button: Next')
    }
  },
  created () {
    let teams = window.clash2018.teams
    delete teams.team5 // death to the duckycrabs
    this.teams = teams
  }
}



// WEBPACK FOOTER //
// ./src/components/assemble/create/Create.js